module.exports = __webpack_public_path__ + "static/media/leamington-spencer-yard-cropped.253c25e6.png";